import {makeAutoObservable} from 'mobx';
import s from '../../s';

class LinoStore {
    public desc1Options: string[] = [];
    public selectedDesc1: string;

    constructor() {
        makeAutoObservable(this);
    }

    getData() {
        const options = s.prod.linos
            .filter(i => !i.isBase && !i.isCAF)
            .flatMap(i => i.desc1.split(',').map(item => item.trim()))
            .sort();

        this.desc1Options = [...new Set(options)];
    }

    setSelected(desc1: string) {
        this.selectedDesc1 = desc1;
    }

    get desc2OptionsFiltered() {
        return this.selectedDesc1 ? s.prod.linos.filter(i => i.desc1.toLowerCase().includes(this.selectedDesc1.toLowerCase())).sort((a, b) => a.desc2.localeCompare(b.desc2)) : [];
    }
}

export const linoStore = new LinoStore();
